import * as actionTypes from '../actions/actionTypes'
const defaultState = {
  notifications: []
}

export default (state = defaultState, action) => {
  switch (action.type) {
    case actionTypes.ENQUEUE_SNACKBAR:
      return {
        ...state,
        notifications: [
          ...state.notifications,
          {
            key: action.key,
            ...action.notification
          }
        ]
      }

    case actionTypes.CLOSE_SNACKBAR:
      return {
        ...state,
        notifications: state.notifications.map(notification =>
          action.dismissAll || notification.key === action.key
            ? { ...notification, dismissed: true }
            : { ...notification }
        )
      }

    case actionTypes.REMOVE_SNACKBAR:
      return {
        ...state,
        notifications: state.notifications.filter(notification => notification.key !== action.key)
      }
    case actionTypes.SIGNOUT_SUCCESS:
    case actionTypes.SIGNOUT_FAILED:
      return { ...defaultState }
    default:
      return state
  }
}
